import axios from "axios";
import { resolveApiUrl } from "../assets/GlobalVariables";

function isPackageComparePayload(payload) {
  if (!payload || typeof payload !== "object") return false;
  return payload.offer_type === "package_compare";
}

function isOrganizedTourOfferPayload(payload) {
  return payload?.offer_type === "organized_tour";
}

/** תאימות ל-validators צד שרת: stub של selected_room כמו ב-package_compare */
function withOrganizedTourOfferMetadata(body) {
  const payload = body?.payload || {};
  const pub = payload.public_view_model || {};
  return {
    ...body,
    offer_type: "organized_tour",
    snapshot_version: 2,
    payload: {
      ...payload,
      offer_type: "organized_tour",
      snapshot_version: 2,
      selection: {
        mode: "organized_tour",
        selected_room: {
          roomId: "organized-tour-smart-quote",
          roomName: String(pub.tour_title_he || "").slice(0, 140) || "OrganizedTour",
        },
      },
    },
  };
}

function validatePackageComparePayload(payload) {
  const selectedPackages = Array.isArray(payload?.selectedPackages)
    ? payload.selectedPackages
    : [];
  const finalCustomerPrices = Array.isArray(payload?.finalCustomerPrices)
    ? payload.finalCustomerPrices
    : [];

  if (selectedPackages.length < 2 || selectedPackages.length > 4) {
    throw new Error("יש לבחור בין 2 ל-4 חבילות להצעה");
  }

  const finalByPackageId = new Map(
    finalCustomerPrices.map((row) => [String(row?.packageId ?? ""), row])
  );
  const hasMissingFinalPrice = selectedPackages.some((pkg) => {
    const packageId = String(pkg?.packageId ?? "");
    if (!packageId) return true;
    const row = finalByPackageId.get(packageId);
    return !row || !Number.isFinite(Number(row.finalPriceIls));
  });
  if (hasMissingFinalPrice) {
    throw new Error("חסר מחיר סופי לפחות לאחת מהחבילות");
  }
}

function withCompareMetadata(body) {
  const payload = body?.payload || {};
  const selectedPackages = Array.isArray(payload?.selectedPackages)
    ? payload.selectedPackages
    : [];
  const firstPackage = selectedPackages[0] || null;
  return {
    ...body,
    offer_type: "package_compare",
    snapshot_version: 2,
    payload: {
      ...payload,
      offer_type: "package_compare",
      snapshot_version: 2,
      selection: {
        mode: "compare",
        selected_packages: selectedPackages.map((pkg) => ({
          packageId: pkg?.packageId != null ? String(pkg.packageId) : null,
          hotelName: pkg?.hotelName || null,
        })),
        // compatibility-only payload so legacy validators won't treat this as "missing room"
        selected_room: {
          roomId: "compare-v2",
          roomName: "Package Compare Offer",
        },
        selected_package: firstPackage
          ? {
              packageId:
                firstPackage?.packageId != null
                  ? String(firstPackage.packageId)
                  : null,
              hotelName: firstPackage?.hotelName || null,
            }
          : null,
      },
    },
  };
}

/**
 * יצירת קישור ציבורי — דורש sessionID בגוף (אימות סוכן).
 */
export async function createPublicOfferLinkRequest(body) {
  const url = resolveApiUrl("/api/offers/public-links");
  const payload = body?.payload || {};
  const isCompare = isPackageComparePayload(payload);
  const isOrgTour = isOrganizedTourOfferPayload(payload);
  if (isCompare) {
    validatePackageComparePayload(payload);
  }
  const requestBody = isCompare
    ? withCompareMetadata(body)
    : isOrgTour
      ? withOrganizedTourOfferMetadata(body)
      : body;
  if (isCompare) {
    // temporary debug log for package_compare payload verification
    // eslint-disable-next-line no-console
    console.log("[PUBLIC_COMPARE_OFFER_POST_DEBUG]", requestBody);
  }
  if (isOrgTour) {
    // eslint-disable-next-line no-console
    console.log(
      "[ORG_TOUR_SMART_QUOTE_CREATE_TRACE]",
      "[ORG_TOUR_QUOTE_REUSE_EXISTING_FLOW_TRACE]",
      "[ORG_TOUR_QUOTE_DATA_ADAPTER_TRACE]",
      { stage: "public_offer_linksaxios_post_ready", offer_type: "organized_tour" }
    );
  }
  const res = await axios.post(url, requestBody, {
    headers: {
      "Content-Type": "application/json; charset=utf-8",
      Accept: "application/json; charset=utf-8",
    },
    withCredentials: true,
    timeout: 60000,
  });
  return res.data;
}

export async function fetchPublicOfferByToken(token) {
  const safe = encodeURIComponent(String(token || "").trim());
  const url = resolveApiUrl(`/api/offers/public-links/${safe}`);
  const res = await axios.get(url, {
    headers: { Accept: "application/json; charset=utf-8" },
    timeout: 60000,
  });
  return res.data;
}

export async function postPublicOfferInterest(token, body = {}) {
  const safe = encodeURIComponent(String(token || "").trim());
  const url = resolveApiUrl(`/api/offers/public-links/${safe}/interest`);
  const res = await axios.post(
    url,
    body && typeof body === "object" ? body : {},
    {
      headers: {
        "Content-Type": "application/json; charset=utf-8",
        Accept: "application/json; charset=utf-8",
      },
      timeout: 30000,
    }
  );
  return res.data;
}
